import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getProductListInput,
  getProductsListInput,
  getProductVariantInput,
  getProductVariantsInput,
  ProductListLiteModel,
  ProductListModel,
  ProductVariantLiteModel,
} from './model';

export function useGetProductsList(
  input?: getProductsListInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ProductListLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ProductListLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['products', input?.params],
      () =>
        QueryFetchFunction({
          url: 'products',
          params: input?.params,
        }),
      options,
    ),
    ProductListLiteModel,
  );
}

export function useGetProductList(
  input?: getProductListInput,
  options?: UseQueryOptions<ApiResult<ProductListModel>, ApiError>,
): UseQueryResult<ApiResult<ProductListModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['products', input?.id],
      () =>
        QueryFetchFunction({
          url: `products/${input?.id}`,
        }),
      options,
    ),
    ProductListModel,
  );
}

export function useGetProductVariants(
  input?: getProductVariantsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ProductVariantLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ProductVariantLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['product-variants', input?.params],
      () =>
        QueryFetchFunction({
          url: 'products/variants',
          params: input?.params,
        }),
      options,
    ),
    ProductVariantLiteModel,
  );
}

export function useGetProductVariant(
  input?: getProductVariantInput,
  options?: UseQueryOptions<ApiResult<ProductVariantLiteModel>, ApiError>,
): UseQueryResult<ApiResult<ProductVariantLiteModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getProductVariant', input?.id],
      () =>
        QueryFetchFunction({
          url: `products/variants/${input?.id}`,
        }),
      options,
    ),
    ProductVariantLiteModel,
  );
}

export function getProductsListKey(input?: getProductsListInput) {
  return ['products', input?.params];
}

export function getProductListKey(input?: getProductListInput) {
  return ['products', input?.id];
}

export function getProductVariantsKey(input?: getProductVariantsInput) {
  return ['product-variants', input?.params];
}

export function getProductVariantKey(input?: getProductVariantInput) {
  return ['product-variants', input?.id];
}
